import styled from "styled-components";
import {ACTIVE} from "../../../../../../themes/css-global-classes";
import {IN_DETAILED_HISTORY} from "../css-classes";

export const PanicButtonTooltipBox = styled.div`
    display: none;
    background-color: white;
    text-align: center;
    border-radius: 0.3rem;
    padding: 0.5rem;
    margin-top: 0.7rem;
    cursor: default;

    position: absolute !important;
    z-index: 107;
    ${({theme}) => theme.font.presets.body};
    font-size: 1.2rem;
    color: ${({theme}) => theme.colors.textDark};

    &.${ACTIVE} {
        display: block;
    }

    &.${IN_DETAILED_HISTORY} {
        @media ${({theme}) => theme.mediaQuery.sAndAbove}{
            @media ${({theme}) => theme.mediaQuery.landscape}{
                left: initial;
                transform: translateX(-58%);
            }
        }
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow}{
        @media ${({theme}) => theme.mediaQuery.portrait}{
            left: 1rem;
            width: calc(100% - 2rem);
            box-sizing: border-box;
        }
    }

    @media ${({theme}) => theme.mediaQuery.hoverNone}{
        padding: 0.5rem 1rem 0.5rem 1rem;
    }
`;
